export { default } from "./AppDrawerTitleText";
